var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simple-container"},[_c('div',{staticClass:"simple"},[_vm._t("default"),_c('p',{staticClass:"mt-5 mb-3 text-muted"},[_vm._v("Oddular © 2016-2020")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }